

export enum MeldungEoEStatus {
  Nicht_Eingereicht = 'Nicht Eingereicht',
  Eingereicht = 'Eingereicht',
  Erledigt = 'Erledigt'
}

export namespace MeldungEoEStatus {
  export function keys(): any[] {
    const values = Object.values(MeldungEoEStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      if (typeof values[i] === 'string') {
        results.push({ id: i, name: values[i].replace('_', ' ') });
      }
    }
    return results;
  }

  export function getValues(): MeldungEoEStatus[] {
    const values = Object.values(MeldungEoEStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}


// -------------------


export enum MeldungEoEReadStatus {
  Ungelesen = 'Ungelesen',
  Gelesen = 'Gelesen'
}

export namespace MeldungEoEReadStatus {
  export function keys(): any[] {
    const values = Object.values(MeldungEoEReadStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      if (typeof values[i] === 'string') {
        results.push({ id: i, name: values[i].replace('_', ' ') });
      }
    }

    return results;
  }

  export function getValues(): MeldungEoEReadStatus[] {
    const values = Object.values(MeldungEoEReadStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}

// -------------------

export enum MeldungEoESchweregrad {
  Keine_Eoe = 'Keine Eoe',
  Leicht = 'Leicht',
  Mittel = 'Mittel',
  Schwer = 'Schwer',
}

export namespace MeldungEoESchweregrad {
  export function keys(): any[] {
    const values = Object.values(MeldungEoESchweregrad) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      if (typeof values[i] === 'string') {
        results.push({ id: i, name: values[i].replace('_', ' ') });
      }
    }

    return results;
  }
}
